import React from 'react'
import './Project.css'




export default function Project(props){    
    
    const name = props.name
    const description = props.description
    const thumbnail = props.thumbnail
    
    const techs = props.tech_list
    const link = props.go

    return(
        <a href={link} className="go_a" target='__blank'>

            <div className="project_main_div">

                <div className="top">

                    <div className="thumbnail_div" style={{
                        background: `url(${thumbnail})`, 
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center'
                        }}>

                    {/* <img src={thumbnail} alt="#" /> */}
                    <span> </span>

                    </div>

                    <div className="tech_div">

                        {techs.map((tech, i) => {
                            return(

                                <div className="logo_tech">
                                    <img src={tech} alt="#" />
                                </div>

                            )
                        })}

                    </div>

                </div>

                <div className="bottom_div">

                        <div className="info_app_div">

                            <h3 className="prject_name">{name}</h3>
                            <p className="project_description">

                                {description}

                            </p>

                        </div>

                </div>



            </div>

        </a>
    )
}